<template>
  <figure
    class="avatar__circle"
    role="img"
    :class="['avatar--' + size]"
  >
    <img
      class="avatar__image"
      :src="src"
      :alt="t('literal.user_avatar')"
      @error="hasImageError = true"
      v-if="src && !hasImageError"
    >

    <fa-icon
      class="avatar__icon"
      :icon="['fas', 'user']"
      :aria-label="t('literal.user_avatar')"
      fixed-width
      v-else
    />
  </figure>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useI18n } from '@/vendors/i18n'

const { avatar } = defineProps({
  avatar: { type: Object, default: () => ({}) },
  size: { type: [String, Number], default: '3' }
})

const { t } = useI18n()

const hasImageError = ref(false)

const src = computed(() => avatar?.url)
</script>

<style scoped lang="scss">
.avatar {
  &__circle {
    background-color: $dw;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;

    &.active {
      border: 2px solid $color--secondary;
    }
  }

  &__image {
    object-fit: cover;
    max-width: 100%;
  }

  &__icon {
    color: $mg;
  }

  @for $size from 1 through 20 {
    &--#{$size} {
      width: 12px * $size;
      height: 12px * $size;

      .avatar__icon {
        font-size: 5px * $size;
      }
    }
  }
}
</style>
